import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './styles/style.module.css';

import sliderNext from 'appSrc/assets/img/right-chev-purple.svg';

export default class RightChevron extends PureComponent {
    render() {
        var inlineStyles = { ...this.props.style };
        if( this.props.size ) {
            inlineStyles.height = this.props.size + 'px';
            inlineStyles.width = ( this.props.size/2 ) + 'px';
        }
        return (
            <div className={ `${ styles.rightChevron } ${ this.props.className }` }
            style={ inlineStyles }
            onClick={ this.props.onClick }
            data-disabled={ this.props.disabled } >
                <img src={ sliderNext } />
            </div>
        );
    }
}
RightChevron.propTypes = {
    size: PropTypes.number,
    className: PropTypes.string,
    onClick: PropTypes.func,
};
RightChevron.defaultProps = {
    className: '',
    onClick: () => {},
};
